/* eslint-disable
	@typescript-eslint/no-unsafe-argument,
	@typescript-eslint/no-unsafe-member-access,
	@typescript-eslint/no-unsafe-call,
	@typescript-eslint/no-unsafe-assignment
*/
import axios from "axios";
import { HandlerType } from "../controls/base/HandlerType";
import { prompt } from "./../Control/Vue/Notifications/Prompts";

export class FeatureLevelSettings implements HandlerType {
	private readonly featureLevelSelect: JQuery;
	private abortController: AbortController | null = null;

	constructor(container: JQuery) {
		this.featureLevelSelect = container.find(".mia-FeatureLevelSelect");
		this.featureLevelSelect.on("change", (event) => void this.onSelectChange(event));
	}

	private async onSelectChange(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		this.abortController?.abort();
		this.abortController = new AbortController();
		const { signal } = this.abortController;

		const featureLevel = this.featureLevelSelect.val();
		const url = this.featureLevelSelect.data("url").replace("PLH_FeatureAccessLevel", featureLevel);

		try {
			const { data } = await axios.get<{ success: boolean }>(url, { signal });

			if (!data.success) {
				prompt(this.featureLevelSelect.data("error"));
			}
		}
		catch (error) {
			if (axios.isCancel(error)) {
				return;
			}

			throw error;
		}
		finally {
			if (this.abortController?.signal === signal) {
				this.abortController = null;
			}
		}
	}
}
